import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { QRCodeModule } from 'angular2-qrcode';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-qr-with-image.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'angular2-qrcode';

const _c0 = ["qrElem"];
class NgxQrWithImageComponent {
    constructor() {
        this.title = 'qr-code-test';
        this.imgHeight = 100;
        this.imgWidth = 100;
        this.show = true;
        this.qrCodeSize = 500;
        this.qrCodeEmitter = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this._imgSrc != undefined) {
            this.addImage(this._imgSrc);
        }
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set imgSrc(val) {
        this._imgSrc = val;
        this.addImage(this._imgSrc);
    }
    /**
     * @return {?}
     */
    get imgSrc() {
        return this._imgSrc;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set content(val) {
        this._content = val;
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.addImage(this._imgSrc);
        }), 500);
    }
    /**
     * @return {?}
     */
    get content() {
        return this._content;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    addImage(url) {
        if (this.qrCode !== undefined) {
            // get canvas dom element
            /** @type {?} */
            let elem = this.qrCode.elementRef.nativeElement.children[0];
            // convert to canvas type
            /** @type {?} */
            let context = elem.getContext("2d");
            // create image
            /** @type {?} */
            let img = new Image();
            // fixed sizes
            /** @type {?} */
            let iWidth = this.imgWidth;
            /** @type {?} */
            let iHeight = this.imgHeight;
            img.onload = (/**
             * @return {?}
             */
            () => {
                context.drawImage(img, (elem.width / 2) - (iWidth / 2), (elem.height / 2) - (iHeight / 2), iWidth, iHeight);
                this.qrCodeEmitter.emit(this.canvasToBlob(this.qrCode.elementRef.nativeElement.children[0]));
            });
            img.src = url;
        }
    }
    // adapted from: https://medium.com/better-programming/convert-a-base64-url-to-image-file-in-angular-4-5796a19fdc21
    /**
     * @param {?} canvas
     * @return {?}
     */
    canvasToBlob(canvas) {
        /** @type {?} */
        let dataurl = canvas.toDataURL("image/png");
        /** @type {?} */
        let byteString = window.atob(dataurl.replace(/^data:image\/(png|jpg);base64,/, ""));
        /** @type {?} */
        const arrayBuffer = new ArrayBuffer(byteString.length);
        /** @type {?} */
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        return new Blob([int8Array], { type: 'image/jpeg' });
    }
}
NgxQrWithImageComponent.ɵfac = function NgxQrWithImageComponent_Factory(t) { return new (t || NgxQrWithImageComponent)(); };
NgxQrWithImageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxQrWithImageComponent, selectors: [["qr-img"]], viewQuery: function NgxQrWithImageComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.qrCode = _t.first);
    } }, inputs: { imgHeight: ["img-height", "imgHeight"], imgWidth: ["img-width", "imgWidth"], show: "show", qrCodeSize: ["size", "qrCodeSize"], imgSrc: ["img", "imgSrc"], content: "content" }, outputs: { qrCodeEmitter: "change" }, decls: 3, vars: 2, consts: [[1, "content"], ["level", "H", "canvas", "true", 3, "value", "size"], ["qrElem", ""]], template: function NgxQrWithImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "qr-code", 1, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx.content)("size", ctx.qrCodeSize);
    } }, directives: [ɵngcc1.QRCodeComponent], encapsulation: 2 });
NgxQrWithImageComponent.propDecorators = {
    imgHeight: [{ type: Input, args: ["img-height",] }],
    imgWidth: [{ type: Input, args: ["img-width",] }],
    show: [{ type: Input, args: ["show",] }],
    qrCodeSize: [{ type: Input, args: ["size",] }],
    qrCodeEmitter: [{ type: Output, args: ["change",] }],
    qrCode: [{ type: ViewChild, args: ['qrElem', { static: false },] }],
    imgSrc: [{ type: Input, args: ["img",] }],
    content: [{ type: Input, args: ["content",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxQrWithImageComponent, [{
        type: Component,
        args: [{
                selector: 'qr-img',
                template: "<div class=\"content\">\r\n    <qr-code [value]=\"content\" [size]=\"qrCodeSize\" level=\"H\" canvas=\"true\" #qrElem></qr-code>\r\n</div>"
            }]
    }], function () { return []; }, { imgHeight: [{
            type: Input,
            args: ["img-height"]
        }], imgWidth: [{
            type: Input,
            args: ["img-width"]
        }], show: [{
            type: Input,
            args: ["show"]
        }], qrCodeSize: [{
            type: Input,
            args: ["size"]
        }], qrCodeEmitter: [{
            type: Output,
            args: ["change"]
        }], imgSrc: [{
            type: Input,
            args: ["img"]
        }], content: [{
            type: Input,
            args: ["content"]
        }], qrCode: [{
            type: ViewChild,
            args: ['qrElem', { static: false }]
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    NgxQrWithImageComponent.prototype._imgSrc;
    /**
     * @type {?}
     * @private
     */
    NgxQrWithImageComponent.prototype._content;
    /** @type {?} */
    NgxQrWithImageComponent.prototype.title;
    /** @type {?} */
    NgxQrWithImageComponent.prototype.imgHeight;
    /** @type {?} */
    NgxQrWithImageComponent.prototype.imgWidth;
    /** @type {?} */
    NgxQrWithImageComponent.prototype.show;
    /** @type {?} */
    NgxQrWithImageComponent.prototype.qrCodeSize;
    /** @type {?} */
    NgxQrWithImageComponent.prototype.qrCodeEmitter;
    /** @type {?} */
    NgxQrWithImageComponent.prototype.qrCode;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-qr-with-image.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxQrWithImageModule {
}
NgxQrWithImageModule.ɵfac = function NgxQrWithImageModule_Factory(t) { return new (t || NgxQrWithImageModule)(); };
NgxQrWithImageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxQrWithImageModule });
NgxQrWithImageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            QRCodeModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxQrWithImageModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxQrWithImageComponent],
                imports: [
                    QRCodeModule
                ],
                exports: [NgxQrWithImageComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxQrWithImageModule, { declarations: function () { return [NgxQrWithImageComponent]; }, imports: function () { return [QRCodeModule]; }, exports: function () { return [NgxQrWithImageComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: psyora-ngx-qr-with-image.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxQrWithImageComponent, NgxQrWithImageModule };

